import type { BackendApi } from '../backend/client'

/**
 * Text-search Google Places (New), proxied server-side so the API key never
 * reaches the client and the field mask (which drives per-call billing) stays
 * fixed. See openapi.yaml `searchPlaces` / `GooglePlace`.
 */
export function searchPlaces(api: BackendApi, query: string, options: { limit?: number } = {}) {
  return api.searchPlaces({ query, limit: options.limit ?? 10 })
}
